import flatpickr from "flatpickr"
import Alpine from "../alpine.js"

Alpine.data("datepicker", (value = null) => ({
  value,
  picker: null,
  init () {
    this.$nextTick(() => {
      this.picker = flatpickr(this.$refs.input, {
        disableMobile: false, // This is confusing but this uses the native date picker on mobile
        appendTo: this.$refs.input.closest("[modal-dialog-panel]") || window.body, // We need to append to modal if the form is inside a modal
        static: true,
        dateFormat: 'M j, Y',
        defaultDate: this.value,
      })
    })
    this.$watch('value', () => this.picker && this.picker.setDate(this.value))
  }
}))
